module.exports = {
  __depends__: [
    require(159),
    require(155),
    require(106)
  ],
  connect: [ 'type', require(99) ]
};
